module.exports = __webpack_public_path__ + "img/25-gladiator-nav.4a6d1ecd.png";